import _sfc_main from "./component-library219.mjs";
import "./component-library220.mjs";
import normalizeComponent from "./component-library81.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "single-item-configurator" }, _vm._l(_setup.filteredVariants, function(variant, index) {
    return _c("div", { key: index, staticClass: "single-item-configurator__variant-group" }, [_c(_setup.VariantSelector, { attrs: { "display-name": variant.displayName, "type": variant.type, "variants": variant.items }, on: { "select-variant": (args) => _vm.$emit("select-variant", args) } })], 1);
  }), 0);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "9a29f575",
  null,
  null
);
const SingleItemConfigurator = __component__.exports;
export {
  SingleItemConfigurator as default
};
